import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import ThemeSettings from "../core/common/theme-settings/themeSettings";
import HorizontalSidebar from "../core/common/horizontal-sidebar";

const Feature = () => {
  const dispatch = useDispatch();
  const headerCollapse = useSelector((state: any) => state.commonSlice.headerCollapse);
  const mobileSidebar = useSelector((state: any) => state.commonSlice.mobileSidebar);
  const miniSidebar = useSelector((state: any) => state.commonSlice.miniSidebar);
  const expandMenu = useSelector((state: any) => state.commonSlice.expandMenu);
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector(
    (state: any) => state.themeSetting.dataSidebarAll
  );
  const dataColorAll = useSelector(
    (state: any) => state.themeSetting.dataColorAll
  );
  const dataTopBarColorAll = useSelector(
    (state: any) => state.themeSetting.dataTopBarColorAll
  );
  const dataTopbarAll = useSelector(
    (state: any) => state.themeSetting.dataTopbarAll
  );
  const location = useLocation();

  useEffect(() => {
    if (dataTheme === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);

  useEffect(() => {
    document.documentElement.setAttribute("data-width", dataWidth);
  }, [dataWidth]);

  useEffect(() => {
    document.documentElement.setAttribute("data-layout", dataLayout);
  }, [dataLayout]);

  useEffect(() => {
    document.documentElement.setAttribute("data-sidebar", dataSidebarAll);
  }, [dataSidebarAll]);

  useEffect(() => {
    document.documentElement.setAttribute("data-color", dataColorAll);
  }, [dataColorAll]);

  useEffect(() => {
    document.documentElement.setAttribute("data-topbarcolor", dataTopBarColorAll);
  }, [dataTopBarColorAll]);

  useEffect(() => {
    document.documentElement.setAttribute("data-topbar", dataTopbarAll);
  }, [dataTopbarAll]);

  return (
    <>
      <div className={`main-wrapper ${headerCollapse ? 'header-collapse' : ''}`}>
        <Header />
        {dataLayout === "horizontal" && <HorizontalSidebar />}
        <Sidebar />
        <Outlet />
        <ThemeSettings />
      </div>
    </>
  );
};

export default Feature;
